import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import TableActionButton from "../../../../@ui/TableActionButton";
import useGetOrderItemInrixVolumeParams, {
  InrixVolumeDayOfWeek,
  InrixVolumeTimePeriod,
} from "../../../map/views/OrderItem/InrixVolumes/controls/GetOrderItemInrixVolumeParams";

const dayOrder: InrixVolumeDayOfWeek[] = [
  InrixVolumeDayOfWeek.SUNDAY,
  InrixVolumeDayOfWeek.MONDAY,
  InrixVolumeDayOfWeek.TUESDAY,
  InrixVolumeDayOfWeek.WEDNESDAY,
  InrixVolumeDayOfWeek.THURSDAY,
  InrixVolumeDayOfWeek.FRIDAY,
  InrixVolumeDayOfWeek.SATURDAY,
];

const dayLabelByValue: Record<InrixVolumeDayOfWeek, string> = {
  [InrixVolumeDayOfWeek.SUNDAY]: "Sun",
  [InrixVolumeDayOfWeek.MONDAY]: "Mon",
  [InrixVolumeDayOfWeek.TUESDAY]: "Tue",
  [InrixVolumeDayOfWeek.WEDNESDAY]: "Wed",
  [InrixVolumeDayOfWeek.THURSDAY]: "Thu",
  [InrixVolumeDayOfWeek.FRIDAY]: "Fri",
  [InrixVolumeDayOfWeek.SATURDAY]: "Sat",
};

const SegmentDayPicker = () => {
  const { timePeriod, dayOfWeek, handleSelectDayOfWeek } =
    useGetOrderItemInrixVolumeParams();

  const currentDay = dayOfWeek ?? InrixVolumeDayOfWeek.SUNDAY;
  const currentIndex = dayOrder.indexOf(currentDay);

  const handlePreviousDay = () => {
    const previousIndex =
      (currentIndex - 1 + dayOrder.length) % dayOrder.length;
    handleSelectDayOfWeek(dayOrder[previousIndex]);
  };

  const handleNextDay = () => {
    const nextIndex = (currentIndex + 1) % dayOrder.length;
    handleSelectDayOfWeek(dayOrder[nextIndex]);
  };

  return (
    <div className="d-flex align-items-center justify-content-between">
      <TableActionButton onClick={handlePreviousDay}>
        <FontAwesomeIcon icon={faChevronLeft} />
      </TableActionButton>
      <span className="fw-semibold fs-12 text-black">
        {dayLabelByValue[currentDay]} volumes
      </span>
      <TableActionButton onClick={handleNextDay}>
        <FontAwesomeIcon icon={faChevronRight} />
      </TableActionButton>
    </div>
  );
};

export default SegmentDayPicker;
